import { If } from '../../Atoms/Conditionals';
import { SOCIAL_MEDIA, SocialMedia } from '../SocialMedia';
import { extractParagraph } from '../utils/authorListUtils';

interface IAUTHOR_CARD_PROPS extends SOCIAL_MEDIA {
  name: string;
  showHeading: boolean;
  designation: string | null;
  authorImg: string;
  description: string | null;
  slug: string;
  isSpecificAuthorPage?: boolean;
}
export const AuthorCard = ({
  name,
  showHeading,
  designation,
  authorImg,
  description,
  linkedin,
  facebook,
  twitter,
  slug,
}: IAUTHOR_CARD_PROPS): JSX.Element => {
  const cardClickHandler = (urlSlug: string) => {
    window.open(urlSlug, '_blank', 'noopener,noreferrer');
  };
  return (
    <div
      className="bg-[#F8FBFF] p-6 rounded-xl mb-6 sm:p-4 block"
      onClick={() => cardClickHandler(`/authors/${slug}/`)}
    >
      <h6 className={`text-s-20 pb-6 sm:hidden ${showHeading ? '' : 'hidden'}`}>
        About the Author
      </h6>

      <div className="pb-6 flex justify-between items-center sm:pb-4">
        <div className="flex gap-4 items-center flex-wrap">
          <If condition={!!authorImg}>
            <div className="author-cirle bg-none w-20 h-20">
              <img src={authorImg} alt="author-img" width={64} height={64} />
            </div>
          </If>
          <div>
            <h4 className="text-base font-bold text-font-500 underline capitalize sm:text-s-18">
              {name}
            </h4>
            <div className="text-s-12 mt-2 text-font-200 font-semibold sm:text-s-14">
              {designation}
            </div>
          </div>
        </div>
        <div className="sm:hidden">
          <SocialMedia
            linkedin={linkedin}
            facebook={facebook}
            twitter={twitter}
          />
        </div>
      </div>

      <If condition={!!description}>
        <p className="text-base">
          {extractParagraph(description as string, 3)}{' '}
          <span className="font-semibold text-font-500">Read more</span>
        </p>
      </If>
    </div>
  );
};
